/* PDF styling only: leave field IDs, validation, routing and wizard structure alone. */
(() => {
  if (window.__drFormDesign) return;
  window.__drFormDesign = true;
  let queued = false;
  function apply() {
    document.querySelectorAll('.contact-form--app:not(.trade-form--application) button.action.submit').forEach(button => {
      button.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().toLowerCase() === 'submit') node.textContent = 'Send';
      });
    });
    document.querySelectorAll('.globo-form-app[data-id="162127"] [data-element-id="select-1"]').forEach(box => {
      box.dataset.drSelectLine = 'true';
      const label = box.querySelector(':scope > label.globo-label');
      const placeholder = box.querySelector('option[value=""]');
      const text = label?.textContent.replace(/\s+/g, ' ').trim();
      if (placeholder && text && placeholder.textContent !== text) placeholder.textContent = text;
    });
    document.querySelectorAll('.contact-form--app .globo-form-control').forEach(box => {
      const label = box.querySelector(':scope > label.globo-label');
      const field = box.querySelector('input:not([type=hidden]):not([type=radio]):not([type=checkbox]):not([type=file]), textarea');
      if (!label || !field) return;
      const name = (label.dataset.label || label.textContent).replace(/\s+/g, ' ').replace(/\s*\*\s*$/, '').trim();
      if (/^Custom Size \(Dimensions\)$/i.test(name)) return;
      if (field.tagName === 'TEXTAREA' && !/^address$/i.test(name)) return;
      if (!box.dataset.drLine) box.dataset.drLine = 'true';
      // Keep the associated label for assistive technology. The PDF presents
      // its text inside the empty field; typed values must not overlap it.
      const placeholder = name + (field.hasAttribute('presence') || field.required ? ' *' : '');
      if (field.placeholder !== placeholder) field.placeholder = placeholder;
      if (field.tagName === 'TEXTAREA') field.rows = 1;
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  }
  function boot() {
    apply();
    new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['placeholder'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('globo.formbuilder.form.loaded', queue);
})();
